<template>
  <div class="all">
    <div class="head clearfix yp-topbar">
      <span class="setting">个人设置</span>
      <router-link to="/more/setinfo" slot="left"  style="display: inline-block;vertical-align: middle;position: absolute;left: 0;top: 32%;">
        <span class="back"></span>
      </router-link>
    </div>
    <div class="main_list">
      <div>
        <mt-cell title="帐号">
          <span style="color: #9b9b9b">{{website}}</span>
        </mt-cell>
      </div>
      <div>
        <mt-cell title="姓名">
          <span style="color: #9b9b9b">{{nickName}}</span>
        </mt-cell>
      </div>
      <div class="avatar" @click="newAvatar">
        <uploader style="display: none" @file-success="fileSuccess" :options="uploadOptions">
          <uploader-btn class="newAvatar" :attrs="attrs">select images</uploader-btn>
        </uploader>
        <form style="display: inline-block" enctype="multipart/form-data" id="uploadForm">
          <label for="imgFile" style="font-size: 16px">头像</label>
          <span style="color: #9b9b9b"><img :src="avatar" ref="img" class="header-img" alt=""></span>
          <i class="iconfont icon-right"
             style="position: absolute;right: .12rem;color: #c7c7cc;font-size: .3rem;font-weight: 900"></i>
        </form>
      </div>
      <div @click="changePhone">
        <mt-cell title="手机号码" is-link>
          <span style="color: #9b9b9b">{{phone}}</span>
        </mt-cell>
      </div>
    </div>
    <mt-actionsheet
      :actions="actions"
      v-model="sheetVisible">
    </mt-actionsheet>
  </div>
</template>
<script type="text/ecmascript-6">
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import tabbar from '../../components/tabbar.vue'
  import {Actionsheet, Toast} from 'mint-ui'
  import $ from 'jquery'

  export default {
    data () {
      return {
        uploadOptions: {
          testChunks: false,
          uploadMethod: 'POST',
          target: apis.app.cloudStorage.baseUrl + '/api/user/avator/upload',
          testMethod: 'POST',
          withCredentials: true,
          chunkSize: 16777216000000000,
          forceChunkSize: true
        },
        avatar: '',
        nickName: '',
        website: '',
        attrs: {
          accept: 'image/*'
        },
        phone: '',
        sheetVisible: false,
        actions: [{
          name: '拍照',
          method: this.photos
        }, {
          name: '从手机相册选择',
          method: this.choose
        }],
        avatarId: ''
      }
    },
    components: {
      tabbar,
      Actionsheet,
      Toast
    },
    created () {
      this._showList()
    },
    methods: {
      fileSuccess (rootFile, file, message, chunk) {
        let _this = this
        this.avatarId = message.split('\"').join('')
        apis.request(cloudApi.info, {value: this.avatarId, type: 1}).then(function (res) {
          apis.request(cloudApi.show).then(function (res) {
            _this.avatar = apis.app.cloudStorage.baseUrl + res.data.avatar
          })
          Toast({
            message: '修改成功',
            iconClass: 'icon-success'
          })
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      },
      newAvatar () {
        $('.newAvatar').click()
      },
      _showList () {
        var _this = this
        apis.request(cloudApi.show, {}).then(function (response) {
          _this.avatar = apis.app.cloudStorage.baseUrl + response.data.avatar
          _this.nickName = response.data.nickName
          _this.website = response.data.website
          _this.phone = response.data.phone
        })
      },
      changeUsername () {
        this.$router.push({path: '/more/changusername'})
      },
      changePhone () {
        this.$router.push({path: '/more/acceptcode'})
      }
    }
  }
</script>
<style scoped lang="scss">
  .all {
    background: #f7f7fa;
    padding-top: 1.28rem;
  }

  .head {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    line-height: 1.28rem;
  }

  .setting {
    position: absolute;
    left: 45%;
    color: #fff;
    font-size: .36rem;
    font-weight: 500;
    margin-left: -.45rem;
  }

  .mint-cell:first-child .mint-cell-wrapper {
    font-size: .28rem !important;
  }

  .mint-cell:last-child {
    background-image: inherit !important;
  }

  .main_list {
    margin-top: .2rem;
    box-shadow: inset 0 -1px 0 0 #e5e5e5, inset 0 1px 0 0 #e5e5e5;
    background-color: #fff;
  }

  .mint-cell-text {
    font-weight: 500;
    font-size: .28rem;
  }

  .mint-cell-value > span > img {
    width: .64rem;
    height: .6rem;
    border: 1px solid #e5e5e5;
    display: block;
  }

  .back {
    width: .2rem;
    height: .3rem;
    /*margin-left: .3rem;*/
    background: url("../../assets/images/back.png") no-repeat;
    background-size: .2rem .3rem;
    display: inline-block;
    float: left;
    margin-top: .1rem;
    margin-left: .2rem;
  }

  .mint-cell-title {
    flex: .95 !important;
  }

  .avatar {
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #e5e5e5;
    padding: 0 .2rem;
    font-size: .28rem;
    form {
      width: 100%;
      position: relative;
      span {
        height: .64rem;
        width: .64rem;
        display: inline-block;
        float: right;
        margin-right: .5rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      input {
        position: absolute;
        right: 0;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
  .header-img{
    background: url('../../assets/images/defaultPic.png');
    display: inline-block;
    background-size: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/showinfo.vue